import { render } from "./AxiosPop.vue?vue&type=template&id=9f276bfa"
import script from "./AxiosPop.vue?vue&type=script&lang=js"
export * from "./AxiosPop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__